<template>
  <div class="p4b__parent p4b__pb-120 reviewPayementOrder_wrapper">
    <div class="container">
      <div
        v-if="isMobile()"
        class="p4b__mobile-back-btn"
      >
        <b-button
          variant="flat"
          class="btn-icon"
          @click="reviewStep === 'paymentForm' ? (reviewStep = 'review') : $router.go(-1)"
        >
          <feather-icon
            size="24"
            icon="ArrowLeftIcon"
          />
        </b-button>
      </div>
      <div class="p4b__toc-logo">
        <img
          :src="logoImg"
          alt="Logo"
        >
      </div>
      <b-row>
        <b-col md="12">
          <div class="rp_review_tittle">
            <h2 class="p4b__payment-review-title">
              Review payment
            </h2>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="loading">
        <b-col md="12">
          <p>Loading order details...</p>
        </b-col>
      </b-row>

      <b-row v-else-if="!validToken">
        <b-col md="12">
          <p>{{ errorMessage }}</p>
        </b-col>
      </b-row>

      <b-row v-else-if="alreadyPaid">
        <b-col md="12">
          <p>{{ orderNo }} is fully paid. This order has no outstanding balance.</p>
        </b-col>
      </b-row>

      <template v-else>
        <b-row
          v-if="reviewStep === 'review'"
          class="rpReview_content_area"
        >
          <b-col md="8">
            <b-card class="rpReview_leftArea">
              <b-card-text class="p4b__payment-review-list">
                <div class="d-flex justify-content-between align-items-center mb-1 rpReview_subTittle">
                  <h4 class="mb-0">
                    Order Items for {{ orderNo }}
                  </h4>
                </div>
                <b-table-simple
                  responsive
                  class="p4b__payment-review-table rpReview_pb_table"
                >
                  <b-tbody>
                    <b-tr
                      v-for="(item, index) in orderItems"
                      :key="index"
                    >
                      <b-td>
                        {{ item.name }}
                      </b-td>
                      <b-td class="text-right">
                        ${{ numberFormat(item.amount) }}
                        <br>
                        <span class="pay-order__item-qty-badge">{{ item.quantity }}</span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <b-tfoot>
                    <b-tr>
                      <b-td>
                        Subtotal
                      </b-td>
                      <b-td class="text-right">
                        <strong>${{ numberFormat(subtotal) }}</strong>
                      </b-td>
                    </b-tr>
                    <b-tr class="prGst_row">
                      <b-td>
                        Inclusive GST (9%)
                      </b-td>
                      <b-td class="text-right">
                        (${{ numberFormat(gst) }})
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <strong>Order Total</strong>
                      </b-td>
                      <b-td class="text-right">
                        <strong>${{ numberFormat(orderTotal) }}</strong>
                      </b-td>
                    </b-tr>
                  </b-tfoot>
                </b-table-simple>
              </b-card-text>
            </b-card>
          </b-col>

          <b-col
            md="4"
            class="paymentReview_sideBar_pb"
          >
            <b-card class="pay-order__diff-card">
              <b-card-text>
                <div class="pay-order__order-total-row">
                  <span>Total Payable</span>
                  <span>${{ numberFormat(totalPayable) }}</span>
                </div>
                <div class="pay-order__order-total-row">
                  <span>Amount Paid</span>
                  <span>${{ numberFormat(amountPaid) }}</span>
                </div>
                <hr class="borderPR_bp">

                <div class="pay-order__additional-payment-box">
                  <h4>Outstanding Amount</h4>
                  <div class="pay-order__additional-payment-amount">
                    ${{ numberFormat(outstandingAmount) }}
                  </div>
                </div>
              </b-card-text>
            </b-card>

            <b-card class="p4b__payment-mode-card">
              <b-card-text>
                <h4>Select your preferred payment mode</h4>
                <div
                  v-if="errorMessage"
                  class="pay-order__error-banner"
                >
                  {{ errorMessage }}
                </div>
                <div class="p4b__payment-mode-btn__wrapper">
                  <b-button
                    block
                    variant="flat"
                    class="p4b__payment-mode-btn"
                    :class="{ 'pay-order__mode-selected': paymentMethod === 'Card' }"
                    @click="selectPaymentMode('Card')"
                  >
                    <div>
                      <b-img
                        :src="visaCard"
                        alt="visa"
                        class="mr-50"
                      />
                      <b-img
                        :src="masterCard"
                        alt="master"
                      />
                    </div>
                    <span>Credit Card</span>
                  </b-button>
                  <b-button
                    block
                    variant="flat"
                    class="p4b__payment-mode-btn"
                    :class="{ 'pay-order__mode-selected': paymentMethod === 'GrabPay' }"
                    @click="selectPaymentMode('GrabPay')"
                  >
                    <b-img
                      :src="grabPay"
                      alt="GrabPay"
                    />
                    <span>GrabPay</span>
                  </b-button>
                  <b-button
                    block
                    variant="flat"
                    class="p4b__payment-mode-btn"
                    :class="{ 'pay-order__mode-selected': paymentMethod === 'PayNow' }"
                    @click="selectPaymentMode('PayNow')"
                  >
                    <div>
                      <b-img
                        :src="payNow"
                        alt="payNow"
                      />
                    </div>
                    <span>PayNow</span>
                  </b-button>
                  <b-button
                    block
                    variant="flat"
                    class="p4b__payment-mode-btn"
                    :class="{ 'pay-order__mode-selected': paymentMethod === 'GooglePay' }"
                    @click="selectPaymentMode('GooglePay')"
                  >
                    <div>
                      <b-img
                        :src="googlePay"
                        alt="GooglePay"
                      />
                    </div>
                    <span>GooglePay</span>
                  </b-button>
                </div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <div
          v-if="reviewStep === 'paymentForm'"
          class="d-flex justify-content-between rpReview_sb_top_row"
        >
          <h4 class="payment-text">
            Total payment
          </h4>
          <h4 class="payment-text">
            ${{ numberFormat(outstandingAmount) }}
          </h4>
        </div>
        <b-card
          v-if="reviewStep === 'paymentForm'"
          class="rpPayment_card_form"
        >
          <b-card-text>
            <template v-if="paymentMethod === 'Card'">
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Name on card*"
                    label-class="p4b__input-label"
                    label-for="h-card-name"
                  >
                    <b-form-input
                      id="h-card-name"
                      v-model="cardName"
                      class="p4b__input-text"
                      placeholder="First name and last name"
                      :state="cardNameValidation ? false : null"
                      @input="cardNameValidation = false"
                    />
                    <small
                      v-if="cardNameValidation"
                      class="text-danger"
                    >
                      {{ cardNameError }}
                    </small>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Card number*"
                    label-class="p4b__input-label"
                    label-for="h-card-no"
                  >
                    <cleave
                      id="h-card-no"
                      v-model="cardNumber"
                      class="form-control p4b__input-text"
                      :raw="false"
                      :options="cleaveOptions.creditCard"
                      :state="cardNumberValidation ? false : null"
                      placeholder="0000 0000 0000 0000"
                      @input="cardNumberValidation = false"
                    />
                    <small
                      v-if="cardNumberValidation"
                      class="text-danger"
                    >
                      {{ cardNumberError }}
                    </small>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Expiry Date*"
                    label-class="p4b__input-label"
                    label-for="h-expiry-date"
                  >
                    <cleave
                      id="h-expiry-date"
                      v-model="cardExpiry"
                      class="form-control p4b__input-text"
                      :raw="false"
                      :options="cleaveOptions.cardExpiry"
                      :state="cardExpiryValidation ? false : null"
                      placeholder="mm/yy"
                      @input="cardExpiryValidation = false"
                    />
                    <small
                      v-if="cardExpiryValidation"
                      class="text-danger"
                    >
                      {{ cardExpiryError }}
                    </small>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="CVV*"
                    label-class="p4b__input-label"
                    label-for="h-cvv"
                  >
                    <cleave
                      id="h-cvv"
                      v-model="cardCvv"
                      class="form-control p4b__input-text"
                      :raw="false"
                      :options="cleaveOptions.cardCvv"
                      :state="cardCvvValidation ? false : null"
                      placeholder="3 digits"
                      @input="cardCvvValidation = false"
                    />
                    <small
                      v-if="cardCvvValidation"
                      class="text-danger"
                    >
                      {{ cardCvvError }}
                    </small>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <template v-else-if="paymentMethod === 'PayNow' && payNowQRImage">
              <div class="pay-order__paynow-qr-wrapper">
                <b-img
                  :src="payNowQRImage"
                  alt="PayNow QR"
                />
                <p>Scan this QR code with your banking app to pay ${{ numberFormat(outstandingAmount) }}.</p>
                <p>QR expires in {{ payNowTimeRemaining }}.</p>
              </div>
            </template>
            <div
              v-else-if="paymentMethod === 'GooglePay'"
              class="text-center mb-2"
            >
              <p>Tap the button below to pay with Google Pay.</p>
              <google-pay-button
                class="sb_google_pay_button"
                environment="TEST"
                button-color="black"
                button-type="pay"
                :payment-request.prop="googlePayRequest"
                @loadpaymentdata="onGooglePayLoadPaymentData"
                @error="onGooglePayError"
              />
            </div>
            <template v-else-if="paymentMethod">
              <p class="pay-order__redirect-note">
                You will be redirected to complete payment via {{ paymentMethod }}.
              </p>
            </template>

            <b-button
              v-if="paymentMethod === 'Card'"
              class="p4b__payment-btn-common"
              block
              :disabled="paymentProcessing"
              @click="confirmAndPay"
            >
              <feather-icon
                icon="DollarSignIcon"
                size="14"
                style="vertical-align: middle;"
              />
              {{ paymentProcessing ? 'Processing...' : 'Confirm and pay' }}
            </b-button>
          </b-card-text>
        </b-card>

        <div
          v-if="awaitingPaymentConfirmation"
          class="axios-loader"
        >
          <loader />
        </div>
      </template>
    </div>

    <!-- modal -->
    <b-modal
      id="modal-pay-order-success"
      modal-class="p4b__payment-status__modal"
      body-class="reduce-padding-0"
      size="470"
      centered
      no-stacking
      no-close-on-backdrop
      hide-footer
      header-class="front-modal"
    >
      <div class="p4b__payment-modal-icon">
        <b-avatar
          class="p4b__payment-modal-avatar-success"
          size="83.33px"
        >
          <span class="d-flex align-items-center">
            <feather-icon
              icon="CheckIcon"
              size="50"
            />
          </span>
        </b-avatar>
      </div>
      <div class="p4b__payment-modal-content">
        <h3>Payment successful</h3>
        <p>Thank you for the payment. Your receipt will be sent to your email <strong>{{ customerEmail }}.</strong></p>
        <b-button
          class="p4b__payment-btn-common"
          :disabled="downloadingInvoice"
          @click="downloadTaxInvoice"
        >
          <b-img
            :src="noteIcon"
            alt="note-icon"
          />
          {{ downloadingInvoice ? 'Downloading...' : 'View tax invoice' }}
        </b-button>
        <div class="p4b__modal-success-copy-text">
          <p>Tax Invoice number: <strong>{{ taxInvoiceNo }}</strong></p>
          <feather-icon
            icon="CopyIcon"
            height="22"
            width="19"
            cursor="pointer"
            color="#D6C691"
            @click="copyTaxInvoiceNumber"
          />
        </div>
      </div>
      <div class="clear" />
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BCard, BCardText, BRow, BCol, BTableSimple, BTbody, BTfoot, BTr, BTd, BImg, BAvatar, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import '@google-pay/button-element'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loader from '../Loader.vue'

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    Loader,
    BRow,
    BCol,
    BTableSimple,
    BTbody,
    BTfoot,
    BTr,
    BTd,
    BImg,
    BAvatar,
    BFormGroup,
    BFormInput,
    Cleave,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/frontend/p4b/logo-yellow.png'),
      // eslint-disable-next-line global-require
      noteIcon: require('@/assets/images/frontend/p4b/icons/note.png'),
      // eslint-disable-next-line global-require
      visaCard: require('@/assets/images/frontend/p4b/payment-logo/visa_4x.png'),
      // eslint-disable-next-line global-require
      masterCard: require('@/assets/images/frontend/p4b/payment-logo/master_4x.png'),
      // eslint-disable-next-line global-require
      grabPay: require('@/assets/images/frontend/p4b/payment-logo/grabpay_4x.png'),
      // eslint-disable-next-line global-require
      payNow: require('@/assets/images/frontend/p4b/payment-logo/paynow_4x.png'),
      // eslint-disable-next-line global-require
      googlePay: require('@/assets/images/frontend/p4b/payment-logo/googlepay_4x.png'),

      loading: true,
      validToken: false,
      alreadyPaid: false,
      errorMessage: '',

      order: null,
      orderNo: '',
      orderItems: [],
      subtotal: 0,
      gst: 0,
      orderTotal: 0,
      totalPayable: 0,
      amountPaid: 0,
      outstandingAmount: 0,
      customerEmail: '',
      taxInvoiceNo: '',

      paymentMethod: '',
      reviewStep: 'review',
      paymentProcessing: false,
      awaitingPaymentConfirmation: false,
      downloadingInvoice: false,

      cardName: '',
      cardNumber: '',
      cardExpiry: '',
      cardCvv: '',
      cardNameValidation: false,
      cardNumberValidation: false,
      cardExpiryValidation: false,
      cardCvvValidation: false,
      cardNameError: '',
      cardNumberError: '',
      cardExpiryError: '',
      cardCvvError: '',

      pendingPaymentId: null,
      paymentPollCount: 0,
      paymentPollTimer: null,
      payNowQRImage: null,
      payNowTimeCountDown: 0,
      payNowTimer: null,

      cleaveOptions: {
        creditCard: { creditCard: true },
        cardExpiry: { date: true, delimiter: '/', datePattern: ['m', 'y'] },
        cardCvv: { blocks: [3], numericOnly: true },
      },

      paymentRequest: {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: 'CARD',
            parameters: {
              allowedAuthMethods: ['PAN_ONLY'],
              allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD'],
            },
            tokenizationSpecification: {
              type: 'PAYMENT_GATEWAY',
              parameters: {
                gateway: 'omise',
                gatewayMerchantId: '',
              },
            },
          },
        ],
        merchantInfo: {
          merchantId: '',
          merchantName: '',
        },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPriceLabel: 'Total',
          totalPrice: '0.00',
          currencyCode: 'SGD',
          countryCode: 'SG',
        },
      },
    }
  },

  computed: {
    googlePayRequest() {
      return {
        ...this.paymentRequest,
        transactionInfo: {
          ...this.paymentRequest.transactionInfo,
          totalPrice: this.numberFormat(this.outstandingAmount),
        },
      }
    },
    payNowTimeRemaining() {
      const minutes = Math.floor(this.payNowTimeCountDown / 60)
      const seconds = this.payNowTimeCountDown % 60
      return `${minutes}min:${seconds.toString().padStart(2, '0')}s`
    },
  },

  beforeMount() {
    document.body.classList.add('p4b__payment-bg')
  },

  mounted() {
    this.loadPaymentLink()
  },

  beforeDestroy() {
    clearTimeout(this.paymentPollTimer)
    clearTimeout(this.payNowTimer)
  },

  methods: {
    loadPaymentLink() {
      this.$http.get(`front-end/pay-order/${this.$route.params.token}/validate`)
        .then(res => {
          this.loading = false
          this.validToken = !!res.data.validToken
          if (!this.validToken) {
            this.errorMessage = res.data.message || 'This payment link is invalid or has expired.'
            return
          }
          this.alreadyPaid = !!res.data.alreadyPaid

          const { order } = res.data
          this.order = order
          this.orderNo = order.stringID
          this.orderItems = order.items || []
          this.subtotal = order.subtotal
          this.gst = order.gstAmount
          this.orderTotal = order.total
          this.totalPayable = order.totalPayable
          this.amountPaid = order.amountPaid
          this.outstandingAmount = res.data.outstandingAmount
          this.customerEmail = order.customerEmail

          if (this.alreadyPaid) return

          // eslint-disable-next-line no-undef
          Omise.setPublicKey(res.data.omisePublicKey)
          this.paymentRequest.allowedPaymentMethods[0].tokenizationSpecification.parameters.gatewayMerchantId = res.data.omisePublicKey
          this.paymentRequest.merchantInfo.merchantId = res.data.gPayMerchantID
          this.paymentRequest.merchantInfo.merchantName = res.data.gPayMerchantName

          this.resumePendingPayment()
        })
        .catch(() => {
          this.loading = false
          this.validToken = false
          this.errorMessage = 'Unable to load this payment link. Please try again later.'
        })
    },

    // Resumes after the browser returns from an external payment step (3D Secure
    // card challenge or GrabPay authorization) - both are full-page redirects, so
    // this component remounts from scratch; only the pending payment id survives,
    // via localStorage, to resume polling and show the success modal.
    resumePendingPayment() {
      const resumePendingPaymentId = localStorage.getItem('payOrderPendingPaymentId')
      if (!resumePendingPaymentId) return
      localStorage.removeItem('payOrderPendingPaymentId')
      this.pendingPaymentId = resumePendingPaymentId
      this.reviewStep = 'paymentForm'
      this.startPollingPaymentStatus()
    },

    selectPaymentMode(mode) {
      this.paymentMethod = mode
      this.reviewStep = 'paymentForm'
      this.errorMessage = ''
      window.scrollTo(0, 0)

      if (mode === 'GrabPay' || mode === 'PayNow') {
        this.initiateAsyncPayment(mode.toLowerCase())
      }
    },

    validateCardForm() {
      let valid = true
      this.cardNameValidation = false
      this.cardNumberValidation = false
      this.cardExpiryValidation = false
      this.cardCvvValidation = false

      if (!this.cardName.trim()) {
        this.cardNameValidation = true
        this.cardNameError = 'Name on card is required.'
        valid = false
      }

      const trimmedCardNumber = this.cardNumber.trim().replace(/\s/g, '')
      if (trimmedCardNumber.length !== 16) {
        this.cardNumberValidation = true
        this.cardNumberError = 'Please enter a valid 16-digit card number.'
        valid = false
      }

      const splitExpiry = this.cardExpiry.split('/')
      if (splitExpiry.length !== 2 || splitExpiry[0].length !== 2 || splitExpiry[1].length !== 2) {
        this.cardExpiryValidation = true
        this.cardExpiryError = 'Please enter a valid expiry date (mm/yy).'
        valid = false
      }

      if (this.cardCvv.length !== 3) {
        this.cardCvvValidation = true
        this.cardCvvError = 'Please enter a valid 3-digit CVV.'
        valid = false
      }

      return valid
    },

    confirmAndPay() {
      if (this.paymentMethod !== 'Card') return
      if (!this.validateCardForm()) return

      this.paymentProcessing = true
      this.errorMessage = ''

      const trimmedCardNumber = this.cardNumber.trim().replace(/\s/g, '')
      const splitExpiry = this.cardExpiry.split('/')
      const tokenParameters = {
        name: this.cardName,
        number: trimmedCardNumber,
        expiration_month: Number(splitExpiry[0]),
        expiration_year: Number(`20${splitExpiry[1]}`),
        security_code: this.cardCvv,
      }

      // eslint-disable-next-line no-undef
      Omise.createToken('card', tokenParameters, (statusCode, response) => {
        if (statusCode !== 200) {
          this.paymentProcessing = false
          this.errorMessage = response.message || 'Invalid card details. Please check and try again.'
          return
        }
        this.chargeWithOmiseToken(response.id, trimmedCardNumber.slice(-4))
      })
    },

    chargeWithOmiseToken(cardToken, cardNumberLast4) {
      const formData = new FormData()
      formData.append('cardToken', cardToken)
      formData.append('cardNumber', cardNumberLast4)
      formData.append('url', window.location.origin)

      this.$http.post(`front-end/pay-order/${this.$route.params.token}/pay/card`, formData)
        .then(res => {
          this.paymentProcessing = false
          if (res.data.orderNos && res.data.orderNos.length) {
            this.onPaymentSuccess(res.data)
          } else if (res.data.redirectURL) {
            if (res.data.pendingPaymentId) localStorage.setItem('payOrderPendingPaymentId', res.data.pendingPaymentId)
            window.open(res.data.redirectURL, '_self')
          } else if (res.data.success || res.data.pending) {
            this.pendingPaymentId = res.data.pendingPaymentId
            this.startPollingPaymentStatus()
          } else {
            this.errorMessage = res.data.message || 'Payment failed. Please try again.'
          }
        })
        .catch(error => {
          this.paymentProcessing = false
          this.errorMessage = (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE
        })
    },

    initiateAsyncPayment(paymentMode) {
      this.paymentProcessing = true
      this.errorMessage = ''

      const formData = new FormData()
      formData.append('paymentMode', paymentMode)
      formData.append('url', window.location.origin)

      this.$http.post(`front-end/pay-order/${this.$route.params.token}/pay/initiate`, formData)
        .then(res => {
          this.paymentProcessing = false
          this.pendingPaymentId = res.data.pendingPaymentId

          if (paymentMode === 'grabpay' && res.data.redirectUrl) {
            localStorage.setItem('payOrderPendingPaymentId', res.data.pendingPaymentId)
            window.open(res.data.redirectUrl, '_self')
          } else if (paymentMode === 'paynow' && res.data.image) {
            this.payNowQRImage = res.data.image
            this.payNowTimeCountDown = 300
            this.countDownPayNowTimer()
            this.startPollingPaymentStatus(false)
          } else {
            this.errorMessage = res.data.message || 'Unable to start payment. Please try again.'
          }
        })
        .catch(error => {
          this.paymentProcessing = false
          this.errorMessage = (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE
        })
    },

    countDownPayNowTimer() {
      clearTimeout(this.payNowTimer)
      if (this.payNowTimeCountDown <= 0) {
        this.regeneratePayNowQR()
        return
      }
      this.payNowTimer = setTimeout(() => {
        this.payNowTimeCountDown -= 1
        this.countDownPayNowTimer()
      }, 1000)
    },

    regeneratePayNowQR() {
      const formData = new FormData()
      formData.append('pendingPaymentId', this.pendingPaymentId)
      formData.append('url', window.location.origin)

      this.$http.post('front-end/pay-order/payment/pay-now/regenerate', formData)
        .then(res => {
          if (res.data.success) {
            this.pendingPaymentId = res.data.pendingPaymentId
            this.payNowQRImage = res.data.image
            this.payNowTimeCountDown = 300
            this.countDownPayNowTimer()
          } else {
            this.errorMessage = res.data.message || 'Payment link has expired.'
          }
        })
        .catch(() => {
          this.errorMessage = 'Unable to refresh PayNow QR code. Please try again.'
        })
    },

    startPollingPaymentStatus(showLoader = true) {
      this.awaitingPaymentConfirmation = showLoader
      this.paymentPollCount = 0
      this.checkForPaymentStatus()
      const poll = () => {
        this.paymentPollCount += 1
        const delay = this.paymentPollCount <= 5 ? 3000 : 10000
        this.paymentPollTimer = setTimeout(() => {
          this.checkForPaymentStatus()
          poll()
        }, delay)
      }
      poll()
    },

    checkForPaymentStatus() {
      this.$http.get(`front-end/pay-order/payment/${this.pendingPaymentId}/check/status`)
        .then(res => {
          if (res.data.success) {
            clearTimeout(this.paymentPollTimer)
            this.awaitingPaymentConfirmation = false
            this.reviewStep = 'review'
            this.onPaymentSuccess(res.data)
          } else if (res.data.failed) {
            clearTimeout(this.paymentPollTimer)
            this.awaitingPaymentConfirmation = false
            this.errorMessage = 'Payment failed. Please try again.'
          }
        })
        .catch(() => {})
    },

    onPaymentSuccess(data) {
      this.taxInvoiceNo = data.invoiceNo || ''
      this.amountPaid = this.totalPayable
      this.outstandingAmount = 0
      this.$root.$emit('bv::show::modal', 'modal-pay-order-success', '')
    },

    onGooglePayLoadPaymentData(event) {
      const { token } = event.detail.paymentMethodData.tokenizationData
      this.errorMessage = ''
      this.paymentProcessing = true

      const tokenParameters = { method: 'googlepay', data: token }
      // eslint-disable-next-line no-undef
      Omise.createToken('tokenization', tokenParameters, (statusCode, response) => {
        if (statusCode !== 200) {
          this.paymentProcessing = false
          this.errorMessage = response.message || 'Google Pay payment failed. Please try again.'
          return
        }
        this.chargeWithOmiseToken(response.id, '')
      })
    },

    onGooglePayError() {
      this.paymentProcessing = false
      this.errorMessage = 'Google Pay payment failed. Please try again.'
    },

    async downloadTaxInvoice() {
      this.downloadingInvoice = true
      try {
        const response = await this.$http.post(
          `front-end/pay-order/${this.$route.params.token}/invoice/pdf/download`,
          null,
          {
            headers: { Accept: 'application/pdf' },
            responseType: 'arraybuffer',
          },
        )
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `Tax-Invoice-${(this.taxInvoiceNo || this.orderNo).replace(/[/\s]/gi, '-')}.pdf`
        link.click()
        link.remove()
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Unable to download tax invoice',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.downloadingInvoice = false
      }
    },

    async copyTaxInvoiceNumber() {
      try {
        await navigator.clipboard.writeText(this.taxInvoiceNo)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Tax invoice number has been copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        // clipboard write not available — no-op
      }
    },
  },
}
</script>
